export interface RRMannequinSettingsModel {
  poseFileLocation: string;
  gender: string;
  bodyType: string;
  shoulderWidth: number;
  chestCirc: number;
  waistCirc: number;
  hipCirc: number;
}
